module.exports = __webpack_public_path__ + "img/2-4-ministerio-de-cultura-y-deporte-ICAA.b44758d9.jpg";